import styled from '@xstyled/styled-components'

export type Size = 'l' | 'm' | 's' | 'xs'
export type Variant = 'inverted' | 'warning' | 'primary' | 'secondary'

export interface StyledCommonButtonProps {
  size?: Size
  variant?: Variant
}

export function getButtonNumericSize(size?: Size) {
  let wAndH
  switch (size) {
    case 'l':
      wAndH = 96
      break
    case 'm':
      wAndH = 70
      break
    case 'xs':
      wAndH = 40
      break
    default:
      wAndH = 48
      break
  }
  return { width: wAndH, height: wAndH }
}

export const StyledCommonButton = styled.button<StyledCommonButtonProps>(
  {
    flexShrink: 0,
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    boxSizing: 'border-box',
    '-webkit-tap-highlight-color': 'transparent',
    outline: 'transparent solid 2px',
    outlineOffset: '2px',
    appearance: 'none',
    userSelect: 'none',
    border: 'none'
  },
  props => getButtonNumericSize(props.size),
  props => {
    switch (props.variant) {
      case 'primary':
        return {
          backgroundColor: props.theme.colors.primary.base,
          color: props.theme.colors.white,
          ':hover': {
            backgroundColor: props.theme.colors.primary.d1,
            color: props.theme.colors.white
          }
        }
      case 'warning':
        return {
          backgroundColor: props.theme.colors.grey.l4,
          color: props.theme.colors.grey.d3,
          ':hover': {
            backgroundColor: props.theme.colors.red.base,
            color: props.theme.colors.white
          }
        }
      case 'inverted':
        return {
          backgroundColor: props.theme.colors.grey.d3,
          color: props.theme.colors.white,
          ':hover': {
            backgroundColor: props.theme.colors.grey.d4
          }
        }
      case 'secondary':
      default:
        return {
          backgroundColor: props.theme.colors.grey.l4,
          color: props.theme.colors.grey.d3,
          ':hover': {
            backgroundColor: props.theme.colors.grey.l2
          }
        }
    }
  }
)
